import { UpdateUserLocalisation } from '../editUser/updateUserLocalisation';
import { useHasPermission } from '../../../hooks/useHasPermission';
import metierIcon from '../../../images/metierSideBarIcon.svg';
import polesIcon from '../../../images/polesSideBarIcon.svg';
import sitesIcon from '../../../images/sitesSideBarIcon.svg';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Iconify from '../../Iconify';
import { useState } from 'react';
import '../../../css/users/userLocalisation.css';

const UserLocalisation = () => {

    const { t } = useTranslation();
    const userDetailsData = useSelector((state) => state.UserDetailsData);
    const hasMachineUpdatePermission = useHasPermission('user_update');

    const [updateUserLocalisation, setUpdateUserLocalisation] = useState(false);

    return (
        <Box className='userLocalisation_main_box'>
            <Box className='userLocalisation_box'>
                <Box className='localisation_edit_box'>
                    <Typography className='userLocalisation_title'>{t('Localisation et rattachement')}</Typography>
                    {hasMachineUpdatePermission && <Iconify className='userLocalisation_edit_icon' icon={"ic:outline-edit"} onClick={() => setUpdateUserLocalisation(true)} />}
                </Box>
                <Box className='userLocalisation_icon_title_response_box'>
                    <Iconify icon={"oui:vis-map-region"} width="32px" />
                    <Box className='userLocalisation_response_box'>
                        <Typography className='userLocalisation_text'>{t('Region :')}</Typography>
                        {userDetailsData?.user_region?.length > 0 ?
                            <Box className='userLocalisation_text_metier_array'>
                                {userDetailsData?.user_region?.map(region =>
                                    <Typography className='userLocalisation_text_metier'>{region?.region?.name}</Typography>
                                )}
                            </Box>
                            :
                            <Typography className='userLocalisation_text'>--</Typography>
                        }
                    </Box>
                </Box>
                <Box className='userLocalisation_icon_title_response_box'>
                    <img src={sitesIcon} alt="icon" loading='lazy' decoding='async' />
                    <Box className='userLocalisation_response_box'>
                        <Typography className='userLocalisation_text'>{t('Site :')}</Typography>
                        {userDetailsData?.user_site?.length > 0 ?
                            <Box className='userLocalisation_text_metier_array'>
                                {userDetailsData?.user_site?.map(site =>
                                    <Typography className='userLocalisation_text_metier'>{site?.site?.name}</Typography>
                                )}
                            </Box>
                            :
                            <Typography className='userLocalisation_text'>--</Typography>
                        }
                    </Box>
                </Box>
                <Box className='userLocalisation_icon_title_response_box'>
                    <img src={polesIcon} alt="icon" loading='lazy' decoding='async' />
                    <Box className='userLocalisation_response_box'>
                        <Typography className='userLocalisation_text'>{t('Pole :')}</Typography>
                        {userDetailsData?.user_pole?.length > 0 ?
                            <Box className='userLocalisation_text_metier_array'>
                                {userDetailsData?.user_pole?.map(pole =>
                                    <Typography className='userLocalisation_text_metier'>{pole?.pole?.name}</Typography>
                                )}
                            </Box>
                            :
                            <Typography className='userLocalisation_text'>--</Typography>
                        }
                    </Box>
                </Box>
                <Box className='userLocalisation_icon_title_response_box'>
                    <Box className='userLocalisation_icon_title_box'>
                        <img src={metierIcon} alt="icon" loading='lazy' decoding='async' />
                        <Typography className='userLocalisation_text'>{t('Métiers :')}</Typography>
                    </Box>

                    <Box className='userLocalisation_response_box'>
                        {userDetailsData?.user_metier?.length > 0 ?
                            <Box className='userLocalisation_text_metier_array'>
                                {userDetailsData?.user_metier?.map(metier =>
                                    <Typography className='userLocalisation_text_metier'>{metier.metier.name}</Typography>
                                )}
                            </Box>
                            :
                            <Typography className='userLocalisation_text'>--</Typography>
                        }
                    </Box>
                </Box>
            </Box>
            {updateUserLocalisation &&
                <UpdateUserLocalisation
                    updateUserLocalisation={updateUserLocalisation}
                    setUpdateUserLocalisation={setUpdateUserLocalisation}
                />
            }
        </Box>
    );
}

export default UserLocalisation;